import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import '../../home/styles.scss';

import ArrowForwardIcon from '@mui/icons-material/ArrowForwardRounded';
import { useLocation, useNavigate } from 'react-router-dom';

import ButtonComponent from '../../../common-components/ButtonComponent/ButtonComponent';
import { OverdueContext } from '../../settings/contexts/OverdueContext';

export default function OverduePaymentHeader({ changeTab }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { userDetails } = useSelector((state) => state.user);
  const { setShowOverdueModal } = useContext(OverdueContext);

  return (
    <>
      {userDetails?.subscriptionStatus === 'past_due' && (
        <div className="overdue-row">
          <div className="left-div">
            <h3>Your last monthly payment didn't go through</h3>
            <ButtonComponent
              onClick={() => {
                if (location.pathname === '/dashboard/settings') {
                  changeTab('subscription');
                  setShowOverdueModal(true);
                }
                navigate(`/dashboard/settings?tab=subscription`);
              }}
              variant={'white'}
              style={{ height: '33px', marginLeft: '20px', color: '#7357e9' }}>
              Update Billing Info <ArrowForwardIcon />
            </ButtonComponent>
          </div>
        </div>
      )}
    </>
  );
}
